import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from "@angular/core";
import { Hss } from "@features/history/hss-builder/models/hss";
import { GlobalService } from "@shared/services";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { HssBuilderService } from "../hss-builder.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss", "../hss-builder.component.scss"],
  standalone: true,
  imports: [OverlayPanelModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  @Input() index?: number;
  @Input() hss?: Hss;
  @Input() enhanced?: boolean;

  globalService = inject(GlobalService);
  hssBuilderService = inject(HssBuilderService);

  getChangedClass(didChange: boolean): string {
    if (didChange && this.index !== undefined) {
      return `changed-${this.index % 2}`;
    }
    return "";
  }
}
